
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import QuizTrophy from "./quiz-results/QuizTrophy";
import QuizScoreMessage from "./quiz-results/QuizScoreMessage";
import QuizProgressBar from "./quiz-results/QuizProgressBar";
import QuizRecommendations from "./quiz-results/QuizRecommendations";
import QuizSignUpButton from "./quiz-results/QuizSignUpButton";
import { useConfetti } from "./quiz-results/useConfetti";

interface QuizResultsProps {
  score: number;
  totalQuestions: number;
  onContinue: () => void;
}

const QuizResults = ({ score, totalQuestions, onContinue }: QuizResultsProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const percentage = Math.round((score / totalQuestions) * 100);
  
  // Use the confetti effect hook
  useConfetti();
  
  const handleSignUp = () => {
    toast({
      title: "Great job!",
      description: "Your quiz results will help us find the perfect strategies for you.",
    });
    navigate("/signup");
  };
  
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full flex flex-col items-center text-center relative z-10"
    >
      <QuizTrophy />
      <QuizScoreMessage score={score} totalQuestions={totalQuestions} />
      <QuizProgressBar percentage={percentage} />
      <QuizRecommendations />
      <QuizSignUpButton onClick={handleSignUp} />
    </motion.div>
  );
};

export default QuizResults;
